import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetaService } from './meta.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MetaComponent } from './meta/meta.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
    declarations: [
        MetaComponent
    ],
    exports: [MetaComponent],
    providers: [MetaService],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatChipsModule,
        MatIconModule


    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MetaModule { }
